<template>
  <div class="sidebar-container" :style="sidebarContainer">
    <div :class="{asideisclose:isCollapse}" style="position: relative;height:100%;">
      <div class="vs-sidebar-image" :style="sidebarImageStyle"></div>
      <div class="logo" :style="{'width': this.$store.state.core.maxMenuWidth,'transition': 'all 0.3s ease','backgroundImage': `url(${$store.state.core.logoUrl})`}">
        <div class="system_name">{{systemName}}</div>
      </div>
      <aside class="vs-menu-wrapper" :style="wrapStyle">
        <!--dx  logo增加下划线 -dx_border-botton-->
        <div class="vs-menu-content menu-scroll" :style="contentStyle" @mouseenter="onMouseAction" @mouseleave="onMouseAction">
          <Menu ref="menu" :accordion="accordion" :active-name="currentActive" :open-names="defaultOpeneds" :style="menuStyle" @on-select="onSelect" @on-open-change="onMenuOpenAndClose">
            <template v-for="menu of menus">
              <MenuItem v-if="menu.children==undefined" :name="menu.name" style="overflow:hidden">
              <span class="vs-item-icon" :title="menu.text"><i :class="menu.icon" class="fa-lg"></i></span>
              <span class="vs-item-title" :title="menu.text">{{menu.text}}</span>
              </MenuItem>
              <Submenu v-else :name="menu.menukey">
                <template slot="title">

                  <span class="vs-item-icon" :title="menu.text"><i :class="menu.icon" class="fa-lg" :title="menu.text"></i></span>
                  <span class="vs-item-title" :title="menu.text">{{menu.text}}</span>

                </template>
                <MenuItem v-for="item of menu.children" :name="item.name" :key="item.name" style="padding-left:28px;">
                <span class="vs-item-icon" v-if="menu.icon" :title="item.text"><i :class="item.icon" class="fa-lg"></i></span>
                <span class="vs-item-title" :title="item.text">{{item.text}}</span>
                </MenuItem>
              </Submenu>
            </template>
          </Menu>
        </div>

        <!-- <div class="vs-menu-trigger">
          <span @click="onToggleMenu">
            <i class="fa" :class="`fa-${isCollapse? 'indent' :'outdent'}`"></i>
          </span>
        </div> -->
      </aside>

    </div>

  </div>
</template>
<script>
import SvgIcon from "./svgIcon";

function findRoute(arr, parent, name) {
  for (let i = 0, len = arr.length; i < len; i++) {
    let t = arr[i];
    if (t.name === name) {
      return {
        parent: parent,
        route: t
      };
    } else if (t.children && t.children.length > 0) {
      t = findRoute(t.children, t, name);
      if (t) return t;
    }
  }
  return null;
}

export default {
  components: { SvgIcon },
  props: {
    width: {
      type: Number,
      default: 260
    },
    backgroundColor: {
      type: String,
      default: "#2C2E48"
    },
    color: {
      type: String,
      default: "#b9bbbe"
    },
    activeColor: {
      type: String,
      default: "#fff"
    }
  },
  data() {
    return {
      accordion: true,
      systemName: this.$app.ProjSetting.title, //从配置里取title
      isCollapse: false,
      menus: this.$app.menus,
      wrapStyle: {
        width: this.width + "px",
        // backgroundColor: this.backgroundColor
        backgroundColor: "rgba(27,27,27,.74)"
      },
      contentStyle: {
        // width: this.width + "px",
      },
      menuStyle: {
        // backgroundColor: this.backgroundColor,
        backgroundColor: "transparent",
        width: this.width + 1 + "px"
        // color: this.color
      },
      svgStyle: {
        fill: this.color
      },
      currentActive: "",
      defaultOpeneds: [],
      openedMenuIndex: [],
      openLocked: true,
      sidebarImageStyle: {
        height: 100 + "%",
        width: 100 + "%",
        position: "absolute",
        top: 0,
        left: 0,
        backgroundImage:
          "url(" + require("../../../assets/images/sidebar-1.jpg") + ")",
        zIndex: -1
      },
      sidebarContainer: {
        width: this.width + "px"
      }
    };
  },
  watch: {
    $route: {
      handler: "routeChange",
      immediate: true
    }
  },
  methods: {
    routeChange() {
      const { name } = this.$route;
      const p_obj = findRoute(this.menus, null, name);
      const indexes = [];
      if (p_obj && p_obj.parent) indexes.push(p_obj.parent.name);
      this.defaultOpeneds = indexes;
      this.openedMenuIndex = indexes;
      this.currentActive = name;
    },
    onMenuOpenAndClose(openids) {
      this.openedMenuIndex = openids;
    },
    onMouseAction() {
      if (this.openLocked) return;
      this.onToggleMenu(false);
    },
    onSelect(name) {
      // let { parent, route } = findRoute(this.menus, null, name);
      // if (!parent) {
      //   this.$nextTick(() => {
      //     // this.defaultOpeneds = [];
      //     this.openedMenuIndex = [];
      //     this.$refs.menu.updateOpened();
      //   });
      // }
      this.$app.routeMenuTo(name);
    },
    onToggleMenu(lock = true) {
      this.isCollapse = !this.isCollapse;
      if (lock !== false) {
        this.openLocked = !this.isCollapse;
      }
      // 展开
      if (!this.isCollapse) {
        this.wrapStyle = {
          width: this.width + "px",
          backgroundColor: "rgba(27,27,27,.74)",
          position: "absolute"
        };
        this.sidebarContainer.width = this.width + "px";
        this.$store.commit("core/setMenuWidthforVs", "260px");
        this.defaultOpeneds = [...this.openedMenuIndex];
      } else {
        //收起
        this.sidebarContainer.width = "65px";
        this.wrapStyle.width = "65px";
        this.defaultOpeneds = [];
        this.$store.commit("core/setMenuWidthforVs", "65px");
      }
      this.$nextTick(() => {
        this.$refs.menu.updateOpened();
      });
    }
  }
};
</script>
<style lang="scss">
.vs-menu-content {
  .ivu-menu,
  .ivu-menu-item {
    color: #b9bbbe;
  }
  .ivu-menu-submenu-title,
  .ivu-menu-item {
    margin: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ivu-menu-submenu-title,
  .ivu-menu-item,
  .vs-item-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 30px;
  }

  > ul {
    > li {
      .vs-item-icon {
        & + .vs-item-title {
          margin-left: 16px;
        }
      }
    }
  }

  .ivu-menu li {
    .ivu-menu {
      .vs-item-icon {
        left: 34px;
        & + .vs-item-title {
          margin-left: 16px;
        }
      }
    }
  }

  .ivu-menu-vertical .ivu-menu-item,
  .ivu-menu-vertical .ivu-menu-submenu-title {
    padding: 14px 16px;
    display: flex;
  }

  .ivu-menu-vertical .ivu-menu-item:hover,
  .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    color: #4caf50;
  }

  .ivu-menu-light.ivu-menu-vertical
    .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    // content: '';
    display: none;
  }

  .ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
    color: #fff !important;
    box-shadow: 0 6px 12px 0 rgba(31, 72, 33, 0.75);
    border-radius: 4px;
    background: #4caf50;
  }
}
</style>
<style lang="scss" scoped>
.logo {
  position: absolute;
  // background: url("/static/img/logo-vs.png") no-repeat 15px;
  // background: url("/static/img/logo.png") no-repeat 10px;
  background-repeat: no-repeat;
  background-position: 10px;
  height: 70px;
  z-index: 1;
  display: flex;
  align-items: center;
  .system_name {
    height: 50px;
    padding-left: 60px;
    padding-right: 10px;
    font-size: 17px;
    color: #fff;
    opacity: 1;
    transition: opacity 0.3s ease;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    overflow: hidden;
    text-align: justify;
    white-space: nowrap;
    //   display: -webkit-box;
    //   -webkit-box-orient: vertical;
    //   -webkit-line-clamp: 3;
  }
}
.vs-item-title {
  opacity: 1;
  transition: opacity 0.3s ease;
}
.asideisclose {
  .logo {
    .system_name {
      opacity: 0;
    }
  }
  .vs-item-title {
    opacity: 0;
  }
}
.vs-menu-wrapper {
  display: flex;
  height: calc(100%);
  flex-direction: column;
  transition: all 0.3s ease;
  overflow: hidden;
  padding-top: 70px;

  .vs-menu-content {
    overflow-y: hidden;
    overflow-x: hidden;
    flex-grow: 1;
    box-sizing: border-box;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    &:hover {
      overflow-y: overlay;
    }
  }

  .vs-menu-trigger {
    display: flex;
    height: 50px;
    flex-shrink: 0;
    padding-left: 20px;
    align-items: center;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  svg {
    vertical-align: sub;

    &:hover {
      fill: #ddd !important;
      cursor: pointer;
    }
  }

  .item-title {
    margin-left: 22px;
    transition: all 0.3s ease;
  }
}

.menu-scroll {
  // &::-webkit-scrollbar {
  //     width: 7px;
  // }

  // &::-webkit-scrollbar-track {
  //     background-color: #656990;
  //     border-left: 2px solid transparent
  // }

  // &::-webkit-scrollbar-thumb {
  //     background-color: #2C2E48;
  //     border-left: 2px solid transparent;

  //     &:window-inactive {
  //         background-color: rgba(0, 0, 0, .1)
  //     }
  // }
  &::-webkit-scrollbar {
    width: 5px;
    height: 10px;
    /**/
  }
  &::-webkit-scrollbar-thumb {
    // background: #bfbfbf;
    background: #606870;
    border-radius: 10px;
    &:hover {
      background: #606870;
    }
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }
}
.sidebar-container {
  position: fixed;
  height: calc(100%);
  top: 0;
  transition: all 0.3s ease;
  z-index: 99;
}
.logo-container {
  width: 50px;
  height: 50px;
  overflow: hidden;
  display: block;
}
.vs-sidebar-image {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: all 0.3s ease;
}
.vs-item-icon {
  display: inline-block;
  min-width: 20px;
  width: 20px;
  height: 20px;
  // position: absolute;
  // left: 15px;
  // top: 14px;
}

//底部线条
.vs_border-botton {
  height: 1px;
  width: 231px;
  border-bottom: 1px solid #5b5f61;
  margin-left: 16px;
  margin-right: 13px;
}
// 权限管理图标
.fa-lock:nth-of-type(1) {
  font-size: 1.65em;
}
</style>